var map = {
	"./3dsecure.png": 5121,
	"./adjust.png": 3807,
	"./bush.png": 2922,
	"./drc.png": 1540,
	"./esp.png": 5128,
	"./fleet.png": 25,
	"./hdfc.png": 4977,
	"./hilti.png": 1223,
	"./hungama.png": 2011,
	"./kenamental.png": 8753,
	"./livingtree.png": 1979,
	"./pepsi.png": 2790,
	"./rewards.png": 9617,
	"./tgliving.png": 3071,
	"./toyota.png": 2635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2590;